import {
  ApplicationConfig,
  provideZonelessChangeDetection,
} from '@angular/core';
import {
  provideRouter,
  withComponentInputBinding,
  withInMemoryScrolling,
  withViewTransitions,
} from '@angular/router';

import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import { MyPresets } from '../../styles';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { MessageService } from 'primeng/api';
import { refreshSessionClockInterceptor } from './core/interceptors/refresh-session-clock.interceptor';
import { authRedirectInterceptor } from './core/interceptors/auth-redirect.interceptor';
import { DialogService } from 'primeng/dynamicdialog';
import { pl } from 'primelocale/pl.json';

export const appConfig: ApplicationConfig = {
  providers: [
    MessageService,
    DialogService,
    provideZonelessChangeDetection(),
    provideRouter(
      routes,
      withViewTransitions(),
      withComponentInputBinding(),
      withInMemoryScrolling({ scrollPositionRestoration: 'enabled' }),
    ),
    provideAnimationsAsync(),
    provideHttpClient(
      withInterceptors([
        refreshSessionClockInterceptor,
        authRedirectInterceptor,
      ]),
    ),
    providePrimeNG({
      theme: {
        preset: MyPresets,
        options: {
          darkModeSelector: '.my-app-dark',
        },
      },
      translation: pl,
    }),
  ],
};
